import type { OrderCalculation } from '../../../types/order-calculation';
import type { CheckoutMessage, TicketOfficeView } from '../../../types/ticket-office';
import type { PartialPaymentModalProps } from '../../components/PartialPaymentModal';
import { Api } from '../api';
import { updateCalc } from './update-calc';

export const getPartialPaymentModal = (view: TicketOfficeView): PartialPaymentModalProps => {
    const { state, update } = view;
    const { currencySymbol, lang, paymentMethodOptions, partialPaymentModal: modal } = state;

    const paymentMethodLabel = paymentMethodOptions.find((x) => x.value == modal.paymentMethodValue).label;

    return {
        isSaveDisabled: modal.amountValue == 0,
        submitLabel: lang.summary.pay,
        closeLabel: lang.common.close,
        amountField: {
            label: lang.partialPayment.payWithCultureCard,
            value: modal.amountValue.toString().replace('.', ','),
            prefix: currencySymbol,
            inputmode: 'numeric',
            onChange: (value) => {
                if ((value.endsWith(',') && !(value.indexOf(',') < value.length - 1)) || value.endsWith(',0')) {
                    return;
                }

                const comaReplacedValue = value.replace(',', '.');

                if (parseFloat(comaReplacedValue)) {
                    modal.amountValue = Math.max(0, parseFloat(comaReplacedValue));
                    update();
                } else {
                    modal.amountValue = 0;
                    update();
                }
            },
        },
        toggleModal: () => {
            state.isPartialPaymentModalOpen = !state.isPartialPaymentModalOpen;
            update();
        },
        title: paymentMethodLabel,
        show: true,
        onSubmit: async () => {
            const reqBody = {
                sessionId: state.sessionId,
                method: modal.paymentMethodValue,
                amount: modal.amountValue,
            };

            const response = await Api.postJson(state.urls.addPartialPayment, state.csrfToken, reqBody);

            if (!response.ok) {
                window.toastr.error(state.lang.errors.partialPaymentFailed);
            } else {
                const resBody = (await response.json()) as {
                    calc?: OrderCalculation;
                    outdated?: CheckoutMessage;
                };

                if (resBody.outdated) {
                    state.outdatedMessage = resBody.outdated;
                } else if (resBody.calc) {
                    updateCalc(view, resBody.calc);
                }

                state.isPartialPaymentModalOpen = false;
            }

            update();
        },
    };
};
